import dayjs from '../../../utils/dayjs';
import {
  Avatar,
  Button,
  Card,
  Form,
  InlineGrid,
  InlineStack,
  Icon,
  Link,
  Popover,
  Select,
  SkeletonThumbnail,
  Tag,
  Text,
  TextField,
  Toast,
  BlockStack,
  ExceptionList,
} from '@shopify/polaris';
import StarRating from 'components/starRating';
import QuickUploadImage from 'components/oneclick-upload-image';
import { useCallback, useEffect, useState } from 'react';

import helpers from 'helpers';

import CustomerAssign from './customer.assign';
import QuickSearchUser from 'components/quickSearchUser';
import __ from 'languages/index';
import { TypedCustomer } from 'interface/customer.model';
import { useUpdateReferrer } from 'queries/user_referrer.query';
import __helpers from 'helpers';
import { useUpdateCustomer } from 'queries/customer.query';
import Capacity from 'components/Capacity';
import UserSocialProfiles from 'components/UserSocialProfiles';
import { useAuth } from 'context/AuthContext';

export default function CustomerGeneralDetail({ entity }: { entity: TypedCustomer }) {
  // const loading_user_referrer = useAppSelector(state => state.user_referrer.loading);

  const { mutateAsync: updateReferrer } = useUpdateReferrer();
  const { mutateAsync: updateEntity, isSuccess: updateSuccess, isPending: updating } = useUpdateCustomer();

  const [internalErrorNotice, setInternalErrorNotice] = useState('');
  const [srcImageAvatar, setSrcImageAvatar] = useState('');

  useEffect(() => {
    setSrcImageAvatar(entity?.user_avatar);
  }, [entity]);

  const handQuickUpdateSuccess = useCallback(
    async (res: any) => {
      setSrcImageAvatar(res.media_url);
      try {
        await updateEntity({ user_id: entity?.user_id, user_avatar: res.media_url });
      } catch (e) {}
    },
    [entity]
  );

  const handUploadError = useCallback((err: any) => {
    setInternalErrorNotice(err);
  }, []);

  /**
   * Quick note
   */
  const [showQuickNote, setShowQuickNote] = useState(false);
  const [biotext, setBiotext] = useState('');

  // lấy quyền

  useEffect(() => {
    if (entity) {
      setBiotext(entity.bio || '');
    }
  }, [entity]);

  useEffect(() => {
    if (updateSuccess === true) {
      setShowQuickNote(false);
    }
  }, [updateSuccess]);

  const saveQuickNoteButtonCallback = useCallback(async () => {
    try {
      await updateEntity({ user_id: entity?.user_id, bio: biotext });
    } catch (e) {}
  }, [entity, biotext]);

  const handleQuickNoteChange = useCallback((newValue: string) => setBiotext(newValue), []);

  /**
   * ENd save quick note
   */

  const [showAddReferrer, setShowAddReferrer] = useState(false);
  const addNewReferrer = useCallback(
    async (referrer_id: bigint | string) => {
      try {
        await updateReferrer({ customer_id: entity?.user_id, referrer_id: referrer_id });
      } catch (e) {}
    },
    [entity?.user_id]
  );

  const [popoverActive1, setPopoverActive1] = useState(false);
  const togglePopoverActive1 = useCallback(() => setPopoverActive1((popoverActive) => !popoverActive), []);

  const [quick_displayname_value, setQuick_displayname_value] = useState('');
  useEffect(() => {
    setQuick_displayname_value(entity?.display_name);
  }, [entity]);

  const savingNewDisplayName = useCallback(async () => {
    //
    togglePopoverActive1();
    try {
      await updateEntity({
        user_id: entity?.user_id,
        display_name: quick_displayname_value,
      });
    } catch (e) {}
  }, [quick_displayname_value]);

  return (
    <>
      {internalErrorNotice && <Toast error content={internalErrorNotice} onDismiss={() => setInternalErrorNotice(null)} />}

      <InlineGrid columns={{ xs: '1', sm: '1', md: '1', lg: ['twoThirds', 'oneThird'] }} gap={'400'}>
        <Card>
          <InlineStack align="start" gap="400" blockAlign="center">
            <div>
              <QuickUploadImage onSuccess={handQuickUpdateSuccess} onError={handUploadError} title="">
                <Avatar name={entity?.display_name} customer source={srcImageAvatar ? __helpers.getMediaLink(srcImageAvatar) : null} size="lg" />
              </QuickUploadImage>
            </div>

            <BlockStack gap={'100'}>
              <Popover
                preferredPosition="below"
                preventCloseOnChildOverlayClick
                preferredAlignment="left"
                autofocusTarget="first-node"
                active={popoverActive1}
                activator={
                  <Text as="h2" variant="headingLg" fontWeight="bold">
                    <Link removeUnderline onClick={togglePopoverActive1}>
                      {entity?.user_title && `(${__(entity?.user_title)})`} {entity?.display_name || entity?.user_login}
                    </Link>
                  </Text>
                }
                onClose={togglePopoverActive1}
                ariaHaspopup={false}
                sectioned
              >
                <div style={{ width: '200px' }}>
                  <Form onSubmit={savingNewDisplayName}>
                    <BlockStack gap="400">
                      <TextField
                        label=""
                        placeholder="Tên khách hàng"
                        value={quick_displayname_value}
                        onChange={(text) => {
                          const formattedText = helpers.capitalizeWords(text);
                          setQuick_displayname_value(formattedText);
                        }}
                        autoComplete="off"
                        clearButton
                        onClearButtonClick={() => setQuick_displayname_value('')}
                      />
                      <Button submit size="slim">
                        Lưu lại
                      </Button>
                    </BlockStack>
                  </Form>
                </div>
              </Popover>
              <InlineStack gap={'200'}>
                <Text as="p" variant="bodySm" tone="subdued">
                  Biệt danh: <i>{entity?.user_nickname || 'Chưa có biệt danh'}</i>
                </Text>
                -
                <Text as="p" variant="bodySm" tone="subdued">
                  {`Tham gia ` + String(entity ? helpers.subtractDate(entity?.createdAt) : '1') + ' ngày trước'}
                </Text>
                {entity?.referrer?.referrer_data ? (
                  <Text as="p" variant="bodySm" tone="subdued">
                    {' - '} Giới thiệu bởi{' '}
                    <a href={`/customer/view/${entity?.referrer?.referrer_data?.user_id}`}>
                      {entity?.referrer?.referrer_data?.display_name || entity?.referrer?.referrer_data?.user_email}
                    </a>
                  </Text>
                ) : (
                  <Capacity current_user_can={['manage_customers', 'edit_customers']} onFail={<>Chưa có người giới thiệu</>}>
                    <Popover
                      preferredPosition="below"
                      preventCloseOnChildOverlayClick
                      active={showAddReferrer}
                      activator={
                        <Button variant="plain" disclosure onClick={() => setShowAddReferrer(true)}>
                          Thêm người giới thiệu
                        </Button>
                      }
                      autofocusTarget="first-node"
                      onClose={() => setShowAddReferrer(false)}
                    >
                      <QuickSearchUser
                        title=""
                        user_role=""
                        onClose={(userData: any) => {
                          addNewReferrer(userData.user_id);
                          setShowAddReferrer(false);
                        }}
                      />
                    </Popover>
                  </Capacity>
                )}
              </InlineStack>

              {entity?.user_rate > 0 ? (
                <div>
                  <StarRating num={entity?.user_rate} />
                  <Text as="span" tone="subdued">{`${entity?.user_rate_count} đánh giá`}</Text>
                </div>
              ) : null}
            </BlockStack>
          </InlineStack>

          <br />
          <InlineGrid gap="400" columns={{ xs: 1, sm: 1, md: 1, lg: 4, xl: 4 }} alignItems="center">
            <BlockStack>
              <Text as="p" tone="subdued">
                Đơn hoàn thành
              </Text>
              <Text as="p" variant="headingLg">
                {entity?.customer_to_user?.customer_order_success_count || 0} đơn
              </Text>
            </BlockStack>
            <BlockStack>
              <Text as="p" tone="subdued">
                Đơn hủy
              </Text>
              <Text as="p" variant="headingLg">
                {entity?.customer_to_user?.customer_order_success_count || 0} đơn
              </Text>
            </BlockStack>

            <BlockStack>
              <Text as="p" tone="subdued">
                Chi tiêu
              </Text>
              <Text as="p" variant="headingLg">
                {helpers.formatNumber(entity?.customer_to_user?.customer_moneyspent_count, ',')} vnđ
              </Text>
            </BlockStack>
            <BlockStack>
              <Text as="p" tone="subdued">
                Cuộc gọi
              </Text>
              <Text as="p" variant="headingLg">
                {helpers.formatNumber(entity?.customer_to_user?.customer_total_call, ',')}
              </Text>
            </BlockStack>
            {/* <BlockStack>
              <Text as="p" tone="subdued">
                Giới thiệu
              </Text>
              <Text as="p" variant="headingLg">
                {helpers.formatNumber(entity?.customer_to_user?.customer_referrer_count, ',')} khách
              </Text>
            </BlockStack> */}
          </InlineGrid>
          <br />

          <BlockStack gap={'400'}>
            <div id="admin_customer_gjfhkdu">
              {entity?.user_birthday && (
                <>
                  <Text variant="bodyMd" as="p" fontWeight="bold">
                    Sinh nhật
                  </Text>
                  <Text as="p">
                    {dayjs(new Date(entity?.user_birthday)).format('DD-MM-YYYY')} {'  -  '} {helpers.getAge(new Date(entity?.user_birthday), ' tuổi')}
                  </Text>
                </>
              )}
            </div>

            <div id="admin_customer_bio">
              <Text variant="bodyMd" as="p" fontWeight="bold">
                Bio
              </Text>
              {showQuickNote ? (
                <>
                  <TextField
                    label=""
                    multiline={2}
                    value={biotext}
                    onChange={handleQuickNoteChange}
                    autoComplete="off"
                    maxLength={250}
                    showCharacterCount
                  />
                  <Button variant="plain" onClick={saveQuickNoteButtonCallback} loading={updating}>
                    Save
                  </Button>
                  &nbsp; or &nbsp;
                  <Button
                    variant="plain"
                    onClick={() => {
                      setShowQuickNote(false);
                    }}
                  >
                    Cancel
                  </Button>
                </>
              ) : (
                <Link removeUnderline monochrome onClick={() => setShowQuickNote(true)}>
                  {entity?.bio || 'Khách hàng này chưa có thông tin tự giới thiệu.'}
                </Link>
              )}
            </div>

            <div id="admin_customer_assign">
              <CustomerAssign customerData={entity} />
            </div>
          </BlockStack>
        </Card>
        <Card>
          <Text as="h3" variant="headingMd">
            Thông tin liên hệ
          </Text>

          <br />

          <BlockStack gap={'200'}>
            <Text variant="bodyMd" as="p" fontWeight="bold">
              Địa chỉ:{' '}
              <Text as="span" tone="critical">
                {entity?.user_address || 'Chưa có thông tin'}
              </Text>
            </Text>
          </BlockStack>

          <br />
          <BlockStack gap={'200'}>
            <ExceptionList
              items={[
                {
                  title: 'Email',
                  status: 'warning',
                  description: entity.user_email ? <Link url="#!">{entity.user_email}</Link> : 'Chưa có',
                },

                {
                  title: 'Phone number',
                  status: 'warning',
                  description: entity.user_phonenumber ? <Link url={`tel:` + entity.user_phonenumber}>{entity.user_phonenumber}</Link> : 'Chưa có',
                },
              ]}
            />
          </BlockStack>

          <br />
          <UserSocialProfiles userId={entity?.user_id} />
        </Card>
      </InlineGrid>
    </>
  );
}
